import {
  SUPPLIERS_INDEX_REQUESTED,
  SUPPLIERS_INDEX_SUCCESS,
  SUPPLIERS_INDEX_FAILURE,
  SUPPLIERS_CREATE_REQUESTED,
  SUPPLIERS_CREATE_SUCCESS,
  SUPPLIERS_CREATE_FAILURE,
  SUPPLIERS_UPDATE_REQUESTED,
  SUPPLIERS_UPDATE_SUCCESS,
  SUPPLIERS_UPDATE_FAILURE,
  SUPPLIERS_DELETE_REQUESTED,
  SUPPLIERS_DELETE_SUCCESS,
  SUPPLIERS_DELETE_FAILURE,
  CLEAR_NEW_SUPPLIER,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  status: 'waiting',
  suppliers: [],
  newSupplier: null,
  errors: null
};

const suppliers = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SUPPLIERS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        suppliers: [],
        status: 'requesting',
        errors: null,
      });

    case SUPPLIERS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        suppliers: action.payload.suppliers,
        errors: null
      });

    case SUPPLIERS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        suppliers: [],
        errors: 'error here'
      });

    case SUPPLIERS_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        newSupplier: null,
      });

    case SUPPLIERS_CREATE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        newSupplier: action.payload.newSupplier,
        suppliers: [...state.suppliers, action.payload.newSupplier],
        errors: null
      });

    case SUPPLIERS_CREATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error'
      });

    case CLEAR_NEW_SUPPLIER:
      newState.newSupplier = null;
      return newState;


    case SUPPLIERS_UPDATE_REQUESTED:
      newState.errors = null;
      return newState;

    case SUPPLIERS_UPDATE_SUCCESS:
      newState.newSupplier = action.supplier;
      return newState;

    case SUPPLIERS_UPDATE_FAILURE:
      newState.errors = 'Failed to update supplier'
      return newState;


    case SUPPLIERS_DELETE_REQUESTED:
      newState.suppliers = newState.suppliers.filter(supplier => supplier.id !== action.supplierId);
      newState.errors = null;
      return newState;

    case SUPPLIERS_DELETE_SUCCESS:
      return newState;

    case SUPPLIERS_DELETE_FAILURE:
      newState.errors = 'Failed to delete supplier';
      return newState;



    default:
      return state;
  }
}

export default suppliers;